import { render, staticRenderFns } from "./sale-instant-table.vue?vue&type=template&id=55872440&scoped=true&"
import script from "./sale-instant-table.vue?vue&type=script&lang=js&"
export * from "./sale-instant-table.vue?vue&type=script&lang=js&"
import style0 from "./sale-instant-table.vue?vue&type=style&index=0&id=55872440&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55872440",
  null
  
)

export default component.exports